export default "__VITE_ASSET__DRET$02w__"